import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Paper from "@mui/material/Paper";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import CloseIcon from "@mui/icons-material/Close";
import "./Header.css";
import Logo from "../../assets/namad-logo-removebg-preview.png";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../app/hooks";
import { selectLoggedIn } from "../auth/authSlice";
import AppQrCodeImage from "../../assets/app-qrcode.png";
import { Link, useNavigate } from "react-router-dom";
import NightLightimage from "../../assets/night-light-pars.png";
import DownloadIcon from "../../assets/downloadappp.png";
import SettingIcon from "../../assets/setting-icon-pars.png";
import RoundedButton from "../../components/atomic/RoundedButton";

type Anchor = "top" | "left" | "bottom" | "right";

interface PageInterface {
  text: string;
  link: string;
}
const pages: Array<PageInterface> = [
  {
    text: "market",
    link: "/markets",
  },
  // {
  //   text: "Transaction",
  //   link: "https://panel.parsianbit.com/trade",
  // },

  {
    text: "Invitation-friends",
    link: "/referral",
  },
];
const settings = ["Profile", "Account", "Dashboard", "Logout"];

const TemporaryDrawer = () => {
  const [state, setState] = React.useState({
    left: false,
    right: false,
  });
  const { t } = useTranslation();

  const toggleDrawer =
    (anchor: Anchor, open: boolean) =>
    (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      setState({ ...state, [anchor]: open });
    };

  const list = (anchor: Anchor) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <Stack direction="column">
        <Paper
          elevation={0}
          sx={{
            mb: 5,
            backgroundColor: "inherit",
            display: "flex",
            flexDirection: "row-reverse",
          }}
        >
          <IconButton
            onClick={toggleDrawer(anchor, false)}
            onKeyDown={toggleDrawer(anchor, false)}
          >
            <CloseIcon />
          </IconButton>
        </Paper>
        <Stack spacing={2} sx={{ mx: 2, display: { md: "none" } }}>
          <RoundedButton
            href="https://panel.parsianbit.com/login"
            fullWidth={true}
            sx={{ color: "text.primary", border: "1px solid #fff" }}
          >
            {t("login")}
          </RoundedButton>
          <RoundedButton
            href="https://panel.parsianbit.com/signup"
            fullWidth={true}
            sx={{ color: "text.primary", minWidth: "77px" }}
            style={{
              background:
                "linear-gradient(180deg, #FF3DFF 0%, #0301FF 142.23%)",
            }}
          >
            {t("sign-in")}
          </RoundedButton>
        </Stack>
      </Stack>
      <List sx={{ display: { sm: "none" } }}>
        {pages.map((page, index) => (
          <ListItem key={page.text} disablePadding>
            <ListItemButton>
              <ListItemIcon>
                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
              </ListItemIcon>
              <ListItemText primary={t(page.text)} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      {/* <List>
        {["English", "Usd", "Theme", "Downloads"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton>
              <ListItemIcon>
                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List> */}
    </Box>
  );

  return (
    <div>
      {(["right"] as const).map((anchor) => (
        <React.Fragment key={anchor}>
          <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={toggleDrawer(anchor, true)}
            color="inherit"
          >
            <MenuIcon />
          </IconButton>
          <Drawer
            sx={{
              "& .MuiDrawer-paper": {
                borderRadius: "0!important",
              },
            }}
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
          >
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
};

type User = {
  name: string;
};

interface HeaderProps {
  user?: User;
  onLogin: () => void;
  onLogout: () => void;
  onCreateAccount: () => void;
}

function DownloadAppMenu() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [t] = useTranslation();

  return (
    <div>
      <Button id="download-app-customized-button" onClick={handleClick}>
        <FileDownloadOutlinedIcon />
      </Button>
      <Menu
        id="download-app-customized-menu"
        MenuListProps={{
          "aria-labelledby": "download-app-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <Box sx={{ mx: 2 }}>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <img src={AppQrCodeImage} />
          </Box>
          <Typography sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            {t("scan_for_download")}
          </Typography>
          <Typography sx={{ display: "flex", justifyContent: "center" }}>
            Android - IOS
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "center", mt: 3, mb: 1 }}>
            <Button size={"large"} color={"warning"} variant={"contained"}>
              {t("more_details")}
            </Button>
          </Box>
        </Box>
      </Menu>
    </div>
  );
}

const Header = ({ user, onLogin, onLogout, onCreateAccount }: HeaderProps) => {
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(
    null
  );
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null
  );
  const navigate = useNavigate();

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = (to: string) => {
    navigate(to);
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const isLoggedIn = useAppSelector(selectLoggedIn);

  const { t } = useTranslation();

  // const UserMenu = () => {
  //     return (
  //         <>

  //             <Menu
  //                 sx={{ mt: '45px' }}
  //                 id="menu-appbar"
  //                 anchorEl={anchorElUser}
  //                 anchorOrigin={{
  //                     vertical: 'top',
  //                     horizontal: 'right',
  //                 }}
  //                 keepMounted
  //                 transformOrigin={{
  //                     vertical: 'top',
  //                     horizontal: 'right',
  //                 }}
  //                 open={Boolean(anchorElUser)}
  //                 onClose={handleCloseUserMenu}
  //             >
  //                 {settings.map((setting) => (
  //                     <MenuItem key={setting} onClick={handleCloseUserMenu}>
  //                         <Typography textAlign="center">{setting}</Typography>
  //                     </MenuItem>
  //                 ))}
  //             </Menu>
  //         </>
  //     );
  // };

  return (
    <AppBar position="static" sx={{ bgcolor: "background.navbarBackground" }}>
      <Container maxWidth={false}>
        <Toolbar disableGutters>
          <img
            style={{ marginTop: ".5rem" }}
            src={Logo}
            width={70}
            height={70}
          />
          <Box sx={{ flexGrow: 1, mx: 2 }}>
            <Stack direction="row" sx={{ display: { xs: "none", sm: "flex" } }}>
              <a
                style={{ color: "#fff", textDecoration: "none" }}
                href="https://panel.parsianbit.com/trade"
              >
                <Button
                  color="inherit"
                  variant={"text"}
                  sx={{
                    my: 2,
                    display: "block",
                    "&:hover": { bgcolor: "#030128" },
                  }}
                >
                  معامله
                </Button>
              </a>
              {pages.map((page) => (
                <Button
                  color="inherit"
                  variant={"text"}
                  key={page.text}
                  onClick={() => handleCloseNavMenu(page.link)}
                  sx={{
                    my: 2,
                    display: "block",
                    "&:hover": { bgcolor: "#030128" },
                  }}
                >
                  {t(page.text)}
                </Button>
              ))}
            </Stack>
          </Box>
          <Box sx={{ flexGrow: 0, display: "flex" }}>
            {isLoggedIn ? (
              <Stack
                direction="row"
                sx={{ display: { xs: "none", md: "inline-flex" } }}
                mx={2}
              ></Stack>
            ) : (
              <Stack
                spacing={1}
                direction="row"
                sx={{ display: { xs: "none", md: "inline-flex" } }}
                mx={2}
              >
                <Button
                  href="https://panel.parsianbit.com/login"
                  variant="outlined"
                >
                  {t("login")}
                </Button>
                <Button
                  href="https://panel.parsianbit.com/signup"
                  variant="contained"
                >
                  {t("sign_up")}
                </Button>
              </Stack>
            )}
            <Stack direction={"row"} spacing={0.5}>
              <Button sx={{ minWidth: "unset" }}>
                <Link to="/download-application" style={{ display: "flex" }}>
                  <Box component="img" src={DownloadIcon} alt="download icon" />
                </Link>
              </Button>
            </Stack>
            <Stack
              direction={"row"}
              spacing={1.5}
              sx={{ display: { xs: "none", md: "flex" } }}
            >
              <Stack direction={"row"} spacing={0.25}>
                <RoundedButton
                  href="https://panel.parsianbit.com/login"
                  sx={{ color: "text.primary" }}
                >
                  {t("login")}
                </RoundedButton>
                <RoundedButton
                  href="https://panel.parsianbit.com/signup"
                  sx={{ color: "text.primary", minWidth: "77px" }}
                  style={{
                    background:
                      "linear-gradient(180deg, #FF3DFF 0%, #0301FF 142.23%)",
                  }}
                >
                  {t("sign-in")}
                </RoundedButton>
              </Stack>
            </Stack>
          </Box>
          <Box sx={{ display: { xs: "flex", md: "none" }, minWidth: "unset" }}>
            <TemporaryDrawer />
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
